export const ShopData = {
  namespaced: true,

  state() {
    return {
      showSecondCurrency: false,
      isAllInclusive: null,
      allInclusiveProduct: null,
    };
  },
  getters: {
    showSecondCurrency(state) {
      return state.showSecondCurrency;
    },
    allInclusive(state) {
      return state.isAllInclusive;
    },
    allInclusiveProduct(state) {
      return state.allInclusiveProduct;
    },
  },
  mutations: {
    SetSecondCurrency(state, bool) {
      state.showSecondCurrency = bool;
    },
    setAllInclusive(state, bool) {
      state.isAllInclusive = bool;
    },
    allInclusiveProduct(state, product) {
      state.allInclusiveProduct = product;
    },
  },
};

export default {
  ShopData,
};
